import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=0df93099"
import script from "./CheckForm.vue?vue&type=script&lang=js"
export * from "./CheckForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports